module.exports = __webpack_public_path__ + "img/figuur5.c5d3a7b2.svg";